export default "__VITE_PUBLIC_ASSET__39924122__"